
import * as util from 'util'

import * as big from '../big'
import * as int64 from '../int64'
import * as uuid from '../uuid'

import * as fbe from '../fbe'
import * as core from '../core'
import * as inner from '../inner'

const Big = big.Big // eslint-disable-line
const Int64 = int64.Int64 // eslint-disable-line
const UInt64 = int64.UInt64 // eslint-disable-line
const UUID = uuid.UUID // eslint-disable-line
import {Request} from '../core/Request';
import {FieldModelRequest} from '../core/Request';
import {OrderUpdateResponse} from './OrderUpdateResponse';
import {OrderUpdate} from './OrderUpdate';
import {FieldModelOrderUpdate} from './OrderUpdate';
import {TradeTransactionType} from '../core/TradeTransactionType';
import {FieldModelTradeTransactionType} from '../core/TradeTransactionType';
import {TradeTransactionReason} from '../core/TradeTransactionReason';
import {FieldModelTradeTransactionReason} from '../core/TradeTransactionReason';
import {TradeEvent} from '../entity/TradeEvent';
import {FieldModelTradeEvent} from '../entity/TradeEvent';
import {AccountMarginUpdate} from './AccountMarginUpdate';
import {FieldModelAccountMarginUpdate} from './AccountMarginUpdate';

/**
 * OrderUpdateRequest struct
 */
class OrderUpdateRequest extends Request {
  /**
   * Initialize struct
   * @param {!Request=} parent
   * @param {!OrderUpdate=} order
   * @param {!UUID=} accountGroupId
   * @param {!TradeTransactionType=} transactionType
   * @param {!TradeTransactionReason=} transactionReason
   * @param {number=} profitRate
   * @param {number=} balanceChange
   * @param {number=} closeMarginRate
   * @param {!Array=} tradeEvents
   * @param {string=} externalClientId
   * @param {number=} lastClosePrice
   * @param {number=} lastCloseAmount
   * @param {string=} managerComment
   * @param {AccountMarginUpdate=} accountMarginUpdate
   * @param {number=} transactionTradeVolumeUSD
   * @constructor
   */
  constructor (parent = new Request(), order = new OrderUpdate(), accountGroupId = new UUID(), transactionType = new TradeTransactionType(), transactionReason = new TradeTransactionReason(), profitRate = null, balanceChange = null, closeMarginRate = null, tradeEvents = [], externalClientId = null, lastClosePrice = null, lastCloseAmount = null, managerComment = null, accountMarginUpdate = null, transactionTradeVolumeUSD = null) {
    super()
    super.copy(parent)
    this.Order = order
    this.AccountGroupId = accountGroupId
    this.TransactionType = transactionType
    this.TransactionReason = transactionReason
    this.ProfitRate = profitRate
    this.BalanceChange = balanceChange
    this.CloseMarginRate = closeMarginRate
    this.TradeEvents = tradeEvents
    this.ExternalClientId = externalClientId
    this.LastClosePrice = lastClosePrice
    this.LastCloseAmount = lastCloseAmount
    this.ManagerComment = managerComment
    this.AccountMarginUpdate = accountMarginUpdate
    this.TransactionTradeVolumeUSD = transactionTradeVolumeUSD
  }

  /**
   * Copy struct (shallow copy)
   * @this {!OrderUpdateRequest}
   * @param {!OrderUpdateRequest} other Other struct
   * @returns {!OrderUpdateRequest} This struct
   */
  copy (other) {
    super.copy(other)
    if (other.Order != null) {
      this.Order = OrderUpdate.fromObject(other.Order)
    } else {
      this.Order = null
    }
    if (other.AccountGroupId != null) {
      this.AccountGroupId = new UUID(other.AccountGroupId)
    } else {
      this.AccountGroupId = null
    }
    if (other.TransactionType != null) {
      this.TransactionType = TradeTransactionType.fromObject(other.TransactionType)
    } else {
      this.TransactionType = null
    }
    if (other.TransactionReason != null) {
      this.TransactionReason = TradeTransactionReason.fromObject(other.TransactionReason)
    } else {
      this.TransactionReason = null
    }
    if (other.ProfitRate != null) {
      this.ProfitRate = other.ProfitRate
    } else {
      this.ProfitRate = null
    }
    if (other.BalanceChange != null) {
      this.BalanceChange = other.BalanceChange
    } else {
      this.BalanceChange = null
    }
    if (other.CloseMarginRate != null) {
      this.CloseMarginRate = other.CloseMarginRate
    } else {
      this.CloseMarginRate = null
    }
    if (other.TradeEvents != null) {
      this.TradeEvents = []
      for (let item of other.TradeEvents) {
        if (item != null) {
          let tempItem
          tempItem = TradeEvent.fromObject(item)
          this.TradeEvents.push(tempItem)
        } else {
          this.TradeEvents.push(null)
        }
      }
    } else {
      this.TradeEvents = null
    }
    if (other.ExternalClientId != null) {
      this.ExternalClientId = other.ExternalClientId
    } else {
      this.ExternalClientId = null
    }
    if (other.LastClosePrice != null) {
      this.LastClosePrice = other.LastClosePrice
    } else {
      this.LastClosePrice = null
    }
    if (other.LastCloseAmount != null) {
      this.LastCloseAmount = other.LastCloseAmount
    } else {
      this.LastCloseAmount = null
    }
    if (other.ManagerComment != null) {
      this.ManagerComment = other.ManagerComment
    } else {
      this.ManagerComment = null
    }
    if (other.AccountMarginUpdate != null) {
      this.AccountMarginUpdate = AccountMarginUpdate.fromObject(other.AccountMarginUpdate)
    } else {
      this.AccountMarginUpdate = null
    }
    if (other.TransactionTradeVolumeUSD != null) {
      this.TransactionTradeVolumeUSD = other.TransactionTradeVolumeUSD
    } else {
      this.TransactionTradeVolumeUSD = null
    }
    return this
  }

  /**
   * Clone struct (deep clone)
   * @this {!OrderUpdateRequest}
   * @returns {!OrderUpdateRequest} Cloned struct
   */
  clone () {
    // Serialize the struct to the FBE stream
    let writer = new OrderUpdateRequestModel(new fbe.WriteBuffer())
    writer.serialize(this)

    // Deserialize the struct from the FBE stream
    let reader = new OrderUpdateRequestModel(new fbe.ReadBuffer())
    reader.attachBuffer(writer.buffer)
    return reader.deserialize().value
  }

  /**
   * Is this struct equal to other one?
   * @this {!OrderUpdateRequest}
   * @param {!OrderUpdateRequest} other Other struct
   * @returns {boolean} Equal result
   */
  eq (other) {
    if (!(other instanceof OrderUpdateRequest)) {
      throw new TypeError('Instance of OrderUpdateRequest is required!')
    }
    // noinspection RedundantIfStatementJS
    if (!super.eq(other)) {
      return false
    }
    return true
  }

  /**
   * Convert struct to JSON
   * @this {!OrderUpdateRequest}
   * @returns {!object} Struct value for JSON
   */
  toJSON () {
    let parent = super.toJSON()
    let current = {
      Order: ((this.Order != null) ? this.Order : null),
      AccountGroupId: ((this.AccountGroupId != null) ? this.AccountGroupId.toString() : null),
      TransactionType: ((this.TransactionType != null) ? this.TransactionType : null),
      TransactionReason: ((this.TransactionReason != null) ? this.TransactionReason : null),
      ProfitRate: ((this.ProfitRate != null) ? this.ProfitRate : null),
      BalanceChange: ((this.BalanceChange != null) ? this.BalanceChange : null),
      CloseMarginRate: ((this.CloseMarginRate != null) ? this.CloseMarginRate : null),
      TradeEvents: ((this.TradeEvents != null) ? Array.from(this.TradeEvents, item => ((item != null) ? item : null)) : null),
      ExternalClientId: ((this.ExternalClientId != null) ? this.ExternalClientId : null),
      LastClosePrice: ((this.LastClosePrice != null) ? this.LastClosePrice : null),
      LastCloseAmount: ((this.LastCloseAmount != null) ? this.LastCloseAmount : null),
      ManagerComment: ((this.ManagerComment != null) ? this.ManagerComment : null),
      AccountMarginUpdate: ((this.AccountMarginUpdate != null) ? this.AccountMarginUpdate : null),
      TransactionTradeVolumeUSD: ((this.TransactionTradeVolumeUSD != null) ? this.TransactionTradeVolumeUSD : null)
    }
    return { ...parent, ...current }
  }

  /**
   * Convert JSON to struct
   * @param {!string} json JSON string
   * @returns {!object} Struct value for JSON
   */
  static fromJSON (json) {
    return OrderUpdateRequest.fromObject(JSON.parse(json))
  }

  /**
   * Create struct from object value
   * @param {!OrderUpdateRequest} other Object value
   * @returns {!OrderUpdateRequest} Created struct
   */
  static fromObject (other) {
    return new OrderUpdateRequest().copy(other)
  }

  /**
   * Get the FBE type
   * @this {!OrderUpdateRequest}
   * @returns {!number} FBE type
   */
  get fbeType () {
    return OrderUpdateRequest.fbeType
  }

  /**
   * Get the FBE type (static)
   * @this {!OrderUpdateRequest}
   * @returns {!number} FBE type
   */
  static get fbeType () {
    return 4024
  }
}

export { OrderUpdateRequest };

/**
 * Fast Binary Encoding OrderUpdateRequest field model
 */
class FieldModelOrderUpdateRequest extends fbe.FieldModel {
  /**
   * Initialize field model with the given buffer and offset
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Buffer
   * @param {!number} offset Offset
   * @constructor
   */
  constructor (buffer, offset) {
    super(buffer, offset)
    this._parent = new FieldModelRequest(buffer, 4 + 4)
    this.Order = new FieldModelOrderUpdate(buffer, this._parent.fbeOffset + this._parent.fbeBody - 4 - 4)
    this.AccountGroupId = new fbe.FieldModelUUID(buffer, this.Order.fbeOffset + this.Order.fbeSize)
    this.TransactionType = new FieldModelTradeTransactionType(buffer, this.AccountGroupId.fbeOffset + this.AccountGroupId.fbeSize)
    this.TransactionReason = new FieldModelTradeTransactionReason(buffer, this.TransactionType.fbeOffset + this.TransactionType.fbeSize)
    this.ProfitRate = new fbe.FieldModelOptional(new fbe.FieldModelDouble(buffer, this.TransactionReason.fbeOffset + this.TransactionReason.fbeSize), buffer, this.TransactionReason.fbeOffset + this.TransactionReason.fbeSize)
    this.BalanceChange = new fbe.FieldModelOptional(new fbe.FieldModelDouble(buffer, this.ProfitRate.fbeOffset + this.ProfitRate.fbeSize), buffer, this.ProfitRate.fbeOffset + this.ProfitRate.fbeSize)
    this.CloseMarginRate = new fbe.FieldModelOptional(new fbe.FieldModelDouble(buffer, this.BalanceChange.fbeOffset + this.BalanceChange.fbeSize), buffer, this.BalanceChange.fbeOffset + this.BalanceChange.fbeSize)
    this.TradeEvents = new fbe.FieldModelVector(new FieldModelTradeEvent(buffer, this.CloseMarginRate.fbeOffset + this.CloseMarginRate.fbeSize), buffer, this.CloseMarginRate.fbeOffset + this.CloseMarginRate.fbeSize)
    this.ExternalClientId = new fbe.FieldModelOptional(new fbe.FieldModelString(buffer, this.TradeEvents.fbeOffset + this.TradeEvents.fbeSize), buffer, this.TradeEvents.fbeOffset + this.TradeEvents.fbeSize)
    this.LastClosePrice = new fbe.FieldModelOptional(new fbe.FieldModelDouble(buffer, this.ExternalClientId.fbeOffset + this.ExternalClientId.fbeSize), buffer, this.ExternalClientId.fbeOffset + this.ExternalClientId.fbeSize)
    this.LastCloseAmount = new fbe.FieldModelOptional(new fbe.FieldModelDouble(buffer, this.LastClosePrice.fbeOffset + this.LastClosePrice.fbeSize), buffer, this.LastClosePrice.fbeOffset + this.LastClosePrice.fbeSize)
    this.ManagerComment = new fbe.FieldModelOptional(new fbe.FieldModelString(buffer, this.LastCloseAmount.fbeOffset + this.LastCloseAmount.fbeSize), buffer, this.LastCloseAmount.fbeOffset + this.LastCloseAmount.fbeSize)
    this.AccountMarginUpdate = new fbe.FieldModelOptional(new FieldModelAccountMarginUpdate(buffer, this.ManagerComment.fbeOffset + this.ManagerComment.fbeSize), buffer, this.ManagerComment.fbeOffset + this.ManagerComment.fbeSize)
    this.TransactionTradeVolumeUSD = new fbe.FieldModelOptional(new fbe.FieldModelDouble(buffer, this.AccountMarginUpdate.fbeOffset + this.AccountMarginUpdate.fbeSize), buffer, this.AccountMarginUpdate.fbeOffset + this.AccountMarginUpdate.fbeSize)
  }

  /**
   * Get the core.Request field model
   * @this {!FieldModelOrderUpdateRequest}
   * @returns {!FieldModelRequest} core.Request field model
   */
  get parent () {
    return this._parent
  }

  /**
   * Get the field size
   * @this {!FieldModelOrderUpdateRequest}
   * @returns {!number} Field size
   */
  get fbeSize () {
    return 4
  }

  /**
   * Get the field body size
   * @this {!FieldModelOrderUpdateRequest}
   * @returns {!number} Field body size
   */
  get fbeBody () {
    return 4 + 4 + this.parent.fbeBody - 4 - 4 + this.Order.fbeSize + this.AccountGroupId.fbeSize + this.TransactionType.fbeSize + this.TransactionReason.fbeSize + this.ProfitRate.fbeSize + this.BalanceChange.fbeSize + this.CloseMarginRate.fbeSize + this.TradeEvents.fbeSize + this.ExternalClientId.fbeSize + this.LastClosePrice.fbeSize + this.LastCloseAmount.fbeSize + this.ManagerComment.fbeSize + this.AccountMarginUpdate.fbeSize + this.TransactionTradeVolumeUSD.fbeSize
  }

  /**
   * Get the field extra size
   * @this {!FieldModelOrderUpdateRequest}
   * @returns {!number} Field extra size
   */
  get fbeExtra () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4) > this._buffer.size)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)

    let fbeResult = this.fbeBody + this.parent.fbeExtra + this.Order.fbeExtra + this.AccountGroupId.fbeExtra + this.TransactionType.fbeExtra + this.TransactionReason.fbeExtra + this.ProfitRate.fbeExtra + this.BalanceChange.fbeExtra + this.CloseMarginRate.fbeExtra + this.TradeEvents.fbeExtra + this.ExternalClientId.fbeExtra + this.LastClosePrice.fbeExtra + this.LastCloseAmount.fbeExtra + this.ManagerComment.fbeExtra + this.AccountMarginUpdate.fbeExtra + this.TransactionTradeVolumeUSD.fbeExtra

    this._buffer.unshift(fbeStructOffset)

    return fbeResult
  }

  /**
   * Get the field type
   * @this {!FieldModelOrderUpdateRequest}
   * @returns {!number} Field type
   */
  get fbeType () {
    return FieldModelOrderUpdateRequest.fbeType
  }

  /**
   * Get the field type (static)
   * @this {!FieldModelOrderUpdateRequest}
   * @returns {!number} Field type
   */
  static get fbeType () {
    return 4024
  }

  /**
   * Check if the struct value is valid
   * @this {!FieldModelOrderUpdateRequest}
   * @param {!boolean} fbeVerifyType Verify model type flag, defaults is true
   * @returns {!boolean} Field model valid state
   */
  verify (fbeVerifyType = true) {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return true
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return false
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    if (fbeStructSize < (4 + 4)) {
      return false
    }

    let fbeStructType = this.readUInt32(fbeStructOffset + 4)
    if (fbeVerifyType && (fbeStructType !== this.fbeType)) {
      return false
    }

    this._buffer.shift(fbeStructOffset)
    let fbeResult = this.verifyFields(fbeStructSize)
    this._buffer.unshift(fbeStructOffset)
    return fbeResult
  }

  /**
   * Check if the struct fields are valid
   * @this {!FieldModelOrderUpdateRequest}
   * @param {!number} fbeStructSize FBE struct size
   * @returns {!boolean} Field model valid state
   */
  verifyFields (fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.parent.fbeBody - 4 - 4) > fbeStructSize) {
      return true
    }
    if (!this.parent.verifyFields(fbeStructSize)) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.parent.fbeBody - 4 - 4

    if ((fbeCurrentSize + this.Order.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.Order.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Order.fbeSize

    if ((fbeCurrentSize + this.AccountGroupId.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.AccountGroupId.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.AccountGroupId.fbeSize

    if ((fbeCurrentSize + this.TransactionType.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.TransactionType.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.TransactionType.fbeSize

    if ((fbeCurrentSize + this.TransactionReason.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.TransactionReason.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.TransactionReason.fbeSize

    if ((fbeCurrentSize + this.ProfitRate.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.ProfitRate.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.ProfitRate.fbeSize

    if ((fbeCurrentSize + this.BalanceChange.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.BalanceChange.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.BalanceChange.fbeSize

    if ((fbeCurrentSize + this.CloseMarginRate.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.CloseMarginRate.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.CloseMarginRate.fbeSize

    if ((fbeCurrentSize + this.TradeEvents.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.TradeEvents.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.TradeEvents.fbeSize

    if ((fbeCurrentSize + this.ExternalClientId.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.ExternalClientId.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.ExternalClientId.fbeSize

    if ((fbeCurrentSize + this.LastClosePrice.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.LastClosePrice.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.LastClosePrice.fbeSize

    if ((fbeCurrentSize + this.LastCloseAmount.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.LastCloseAmount.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.LastCloseAmount.fbeSize

    if ((fbeCurrentSize + this.ManagerComment.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.ManagerComment.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.ManagerComment.fbeSize

    if ((fbeCurrentSize + this.AccountMarginUpdate.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.AccountMarginUpdate.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.AccountMarginUpdate.fbeSize

    if ((fbeCurrentSize + this.TransactionTradeVolumeUSD.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.TransactionTradeVolumeUSD.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.TransactionTradeVolumeUSD.fbeSize

    return true
  }

  /**
   * Get the struct value (begin phase)
   * @this {!FieldModelOrderUpdateRequest}
   * @returns {!number} Field model begin offset
   */
  getBegin () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + 4 + 4) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return 0
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    console.assert((fbeStructSize >= (4 + 4)), 'Model is broken!')
    if (fbeStructSize < (4 + 4)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Get the struct value (end phase)
   * @this {!FieldModelOrderUpdateRequest}
   * @param {!number} fbeBegin Field model begin offset
   */
  getEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Get the struct value
   * @this {!FieldModelOrderUpdateRequest}
   * @param {!OrderUpdateRequest} fbeValue Default value, defaults is new OrderUpdateRequest()
   * @returns {!OrderUpdateRequest} OrderUpdateRequest value
   */
  get (fbeValue = new OrderUpdateRequest()) {
    let fbeBegin = this.getBegin()
    if (fbeBegin === 0) {
      return fbeValue
    }

    let fbeStructSize = this.readUInt32(0)
    this.getFields(fbeValue, fbeStructSize)
    this.getEnd(fbeBegin)
    return fbeValue
  }

  /**
   * Get the struct fields values
   * @this {!FieldModelOrderUpdateRequest}
   * @param {!OrderUpdateRequest} fbeValue OrderUpdateRequest value
   * @param {!number} fbeStructSize Struct size
   */
  getFields (fbeValue, fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.parent.fbeBody - 4 - 4) <= fbeStructSize) {
      this.parent.getFields(fbeValue, fbeStructSize)
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.parent.fbeBody - 4 - 4

    if ((fbeCurrentSize + this.Order.fbeSize) <= fbeStructSize) {
      fbeValue.Order = this.Order.get()
    } else {
      fbeValue.Order = new OrderUpdate()
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Order.fbeSize

    if ((fbeCurrentSize + this.AccountGroupId.fbeSize) <= fbeStructSize) {
      fbeValue.AccountGroupId = this.AccountGroupId.get()
    } else {
      fbeValue.AccountGroupId = new UUID()
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.AccountGroupId.fbeSize

    if ((fbeCurrentSize + this.TransactionType.fbeSize) <= fbeStructSize) {
      fbeValue.TransactionType = this.TransactionType.get()
    } else {
      fbeValue.TransactionType = new TradeTransactionType()
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.TransactionType.fbeSize

    if ((fbeCurrentSize + this.TransactionReason.fbeSize) <= fbeStructSize) {
      fbeValue.TransactionReason = this.TransactionReason.get()
    } else {
      fbeValue.TransactionReason = new TradeTransactionReason()
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.TransactionReason.fbeSize

    if ((fbeCurrentSize + this.ProfitRate.fbeSize) <= fbeStructSize) {
      fbeValue.ProfitRate = this.ProfitRate.get()
    } else {
      fbeValue.ProfitRate = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.ProfitRate.fbeSize

    if ((fbeCurrentSize + this.BalanceChange.fbeSize) <= fbeStructSize) {
      fbeValue.BalanceChange = this.BalanceChange.get()
    } else {
      fbeValue.BalanceChange = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.BalanceChange.fbeSize

    if ((fbeCurrentSize + this.CloseMarginRate.fbeSize) <= fbeStructSize) {
      fbeValue.CloseMarginRate = this.CloseMarginRate.get()
    } else {
      fbeValue.CloseMarginRate = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.CloseMarginRate.fbeSize

    if ((fbeCurrentSize + this.TradeEvents.fbeSize) <= fbeStructSize) {
      this.TradeEvents.get(fbeValue.TradeEvents)
    } else {
      fbeValue.TradeEvents.length = 0
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.TradeEvents.fbeSize

    if ((fbeCurrentSize + this.ExternalClientId.fbeSize) <= fbeStructSize) {
      fbeValue.ExternalClientId = this.ExternalClientId.get()
    } else {
      fbeValue.ExternalClientId = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.ExternalClientId.fbeSize

    if ((fbeCurrentSize + this.LastClosePrice.fbeSize) <= fbeStructSize) {
      fbeValue.LastClosePrice = this.LastClosePrice.get()
    } else {
      fbeValue.LastClosePrice = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.LastClosePrice.fbeSize

    if ((fbeCurrentSize + this.LastCloseAmount.fbeSize) <= fbeStructSize) {
      fbeValue.LastCloseAmount = this.LastCloseAmount.get()
    } else {
      fbeValue.LastCloseAmount = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.LastCloseAmount.fbeSize

    if ((fbeCurrentSize + this.ManagerComment.fbeSize) <= fbeStructSize) {
      fbeValue.ManagerComment = this.ManagerComment.get()
    } else {
      fbeValue.ManagerComment = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.ManagerComment.fbeSize

    if ((fbeCurrentSize + this.AccountMarginUpdate.fbeSize) <= fbeStructSize) {
      fbeValue.AccountMarginUpdate = this.AccountMarginUpdate.get()
    } else {
      fbeValue.AccountMarginUpdate = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.AccountMarginUpdate.fbeSize

    if ((fbeCurrentSize + this.TransactionTradeVolumeUSD.fbeSize) <= fbeStructSize) {
      fbeValue.TransactionTradeVolumeUSD = this.TransactionTradeVolumeUSD.get()
    } else {
      fbeValue.TransactionTradeVolumeUSD = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.TransactionTradeVolumeUSD.fbeSize
  }

  /**
   * Set the struct value (begin phase)
   * @this {!FieldModelOrderUpdateRequest}
   * @returns {!number} Field model begin offset
   */
  setBegin () {
    console.assert(((this._buffer.offset + this.fbeOffset + this.fbeSize) <= this._buffer.size), 'Model is broken!')
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructSize = this.fbeBody
    let fbeStructOffset = this._buffer.allocate(fbeStructSize) - this._buffer.offset
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + fbeStructSize) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset <= 0) || ((this._buffer.offset + fbeStructOffset + fbeStructSize) > this._buffer.size)) {
      return 0
    }

    this.writeUInt32(this.fbeOffset, fbeStructOffset)
    this.writeUInt32(fbeStructOffset, fbeStructSize)
    this.writeUInt32(fbeStructOffset + 4, this.fbeType)

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Set the struct value (end phase)
   * @this {!FieldModelOrderUpdateRequest}
   * @param {!number} fbeBegin Field model begin offset
   */
  setEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Set the struct value
   * @this {!FieldModelOrderUpdateRequest}
   * @param {!OrderUpdateRequest} fbeValue OrderUpdateRequest value
   */
  set (fbeValue) {
    let fbeBegin = this.setBegin()
    if (fbeBegin === 0) {
      return
    }

    this.setFields(fbeValue)
    this.setEnd(fbeBegin)
  }

  /**
   * Set the struct fields values
   * @this {!FieldModelOrderUpdateRequest}
   * @param {OrderUpdateRequest} fbeValue OrderUpdateRequest value
   */
  setFields (fbeValue) {
    this.parent.setFields(fbeValue)
    this.Order.set(fbeValue.Order)
    this.AccountGroupId.set(fbeValue.AccountGroupId)
    this.TransactionType.set(fbeValue.TransactionType)
    this.TransactionReason.set(fbeValue.TransactionReason)
    this.ProfitRate.set(fbeValue.ProfitRate)
    this.BalanceChange.set(fbeValue.BalanceChange)
    this.CloseMarginRate.set(fbeValue.CloseMarginRate)
    this.TradeEvents.set(fbeValue.TradeEvents)
    this.ExternalClientId.set(fbeValue.ExternalClientId)
    this.LastClosePrice.set(fbeValue.LastClosePrice)
    this.LastCloseAmount.set(fbeValue.LastCloseAmount)
    this.ManagerComment.set(fbeValue.ManagerComment)
    this.AccountMarginUpdate.set(fbeValue.AccountMarginUpdate)
    this.TransactionTradeVolumeUSD.set(fbeValue.TransactionTradeVolumeUSD)
  }
}

export { FieldModelOrderUpdateRequest };

/**
 * Fast Binary Encoding OrderUpdateRequest model
 */
class OrderUpdateRequestModel extends fbe.Model {
  /**
   * Initialize model with the given buffer
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Read/Write buffer, defaults is new fbe.WriteBuffer()
   * @constructor
   */
  constructor (buffer = new fbe.WriteBuffer()) {
    super(buffer)
    this._model = new FieldModelOrderUpdateRequest(this.buffer, 4)
  }

  /**
   * Get the OrderUpdateRequest model
   * @this {!OrderUpdateRequestModel}
   * @returns {!FieldModelOrderUpdateRequest} model OrderUpdateRequest model
   */
  get model () {
    return this._model
  }

  /**
   * Get the model size
   * @this {!OrderUpdateRequestModel}
   * @returns {!number} Model size
   */
  get fbeSize () {
    return this.model.fbeSize + this.model.fbeExtra
  }

  /**
   * Get the model type
   * @this {!OrderUpdateRequestModel}
   * @returns {!number} Model type
   */
  get fbeType () {
    return OrderUpdateRequestModel.fbeType
  }

  /**
   * Get the model type (static)
   * @this {!OrderUpdateRequestModel}
   * @returns {!number} Model type
   */
  static get fbeType () {
    return FieldModelOrderUpdateRequest.fbeType
  }

  /**
   * Check if the struct value is valid
   * @this {!OrderUpdateRequestModel}
   * @returns {!boolean} Model valid state
   */
  verify () {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return false
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    if (fbeFullSize < this.model.fbeSize) {
      return false
    }

    return this.model.verify()
  }

  /**
   * Create a new model (begin phase)
   * @this {!OrderUpdateRequestModel}
   * @returns {!number} Model begin offset
   */
  createBegin () {
    return this.buffer.allocate(4 + this.model.fbeSize)
  }

  /**
   * Create a new model (end phase)
   * @this {!OrderUpdateRequestModel}
   * @param {!number} fbeBegin Model begin offset
   */
  createEnd (fbeBegin) {
    let fbeEnd = this.buffer.size
    let fbeFullSize = fbeEnd - fbeBegin
    this.writeUInt32(this.model.fbeOffset - 4, fbeFullSize)
    return fbeFullSize
  }

  /**
   * Serialize the struct value
   * @this {!OrderUpdateRequestModel}
   * @param {!OrderUpdateRequest} value OrderUpdateRequest value
   * @return {!number} Model begin offset
   */
  serialize (value) {
    let fbeBegin = this.createBegin()
    this.model.set(value)
    return this.createEnd(fbeBegin)
  }

  /**
   * Deserialize the struct value
   * @this {!OrderUpdateRequestModel}
   * @param {!OrderUpdateRequest} value OrderUpdateRequest value, defaults is new OrderUpdateRequest()
   * @return {!object} Deserialized OrderUpdateRequest value and its size
   */
  deserialize (value = new OrderUpdateRequest()) {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return { value: new OrderUpdateRequest(), size: 0 }
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    console.assert((fbeFullSize >= this.model.fbeSize), 'Model is broken!')
    if (fbeFullSize < this.model.fbeSize) {
      return { value: new OrderUpdateRequest(), size: 0 }
    }

    this.model.get(value)
    return { value: value, size: fbeFullSize }
  }

  /**
   * Move to the next struct value
   * @this {!OrderUpdateRequestModel}
   * @param {!number} prev Previous OrderUpdateRequest model size
   */
  next (prev) {
    this.model.fbeShift(prev)
  }
}

export { OrderUpdateRequestModel };
OrderUpdateRequest.__has_response = true;
OrderUpdateRequest.__response_class = OrderUpdateResponse;
